import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_60qkgonvoc: FaireBrandEntity = {
  token: "b_60qkgonvoc",
  type: "brand",
  name: "SlimSpa The Body Care Specialists",
  avatarUrl:
    "https://cdn.faire.com/fastly/777cda278728cc551cbf7633b62db7ef5b582d722eb85a5303c73d48a403bea8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/cae590daaf05531150708362989340b7d71b79d7df990433686b1b26042fcd6d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/777cda278728cc551cbf7633b62db7ef5b582d722eb85a5303c73d48a403bea8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cae590daaf05531150708362989340b7d71b79d7df990433686b1b26042fcd6d.jpeg",
  location: "Miami, FL, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 8,
  isTopShop: true,
  isInsider: true,
  description:
    "My name is Rey Colina, founder and CEO of SlimSpa. Over 25 years ago, I began my journey in a small New York spa, where I discovered that true results in body care go beyond treatments alone—they require the right products, knowledge, and guidance.\n\nThat vision inspired SlimSpaOnline.com, a brand created to empower estheticians and spa owners with professional-grade body care solutions. From advanced gels, wraps, and protocols to training and ongoing support, we help professionals deliver visible, lasting results their clients love.\n\nAt SlimSpa, we don’t believe in “miracle creams.” Every product we carry is researched, tested, and designed to support real transformation—helping reduce cellulite, sculpt, tone, and improve confidence.\n\nFor more than two decades, we’ve stood by our mission: Transforming Bodies, Changing Lives. Today, SlimSpa is more than a supplier—we’re a partner in your professional growth. When you choose SlimSpa, you gain not only high-quality products but also a team committed to your success.\n\nJoin us, and let’s shape the future of beauty and wellness together.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:49.147Z",
    importedBy: "entity-db-cli",
  },
};
